import React from "react";
import { IoIosCart } from "react-icons/io";
import bg4 from "../../../assets/utils/images/dropdown-header/abstract4.jpg";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  DropdownItem,
} from "reactstrap";

export default function Cart() {
  const handleRedirect = () => {
    const baseUrl = window.location.origin;
    window.location.href = `${baseUrl}/architectui-react-pro#/cart`;
  };
  return (
    <div className="header-dots header-btn-lg pe-0">
      <UncontrolledDropdown>
        <DropdownToggle className="p-0" color="link" onClick={handleRedirect}>
          <div className="icon-wrapper icon-wrapper-alt rounded-circle">
            <div className="icon-wrapper-bg bg-success" />
            <IoIosCart color="#3ac47d" fontSize="23px" />
          </div>
        </DropdownToggle>
      </UncontrolledDropdown>
    </div>
  );
}